import React from 'react';

import type { SlideProps } from '@material-ui/core';
import { Slide } from '@material-ui/core';

type SlideUpProps = Omit<SlideProps, 'direction'>;

const SlideUp = (
  props: SlideUpProps,
  ref: React.Ref<HTMLElement>
): React.ReactElement | null => {
  return <Slide ref={ref} direction="up" {...props} />;
};

export default React.forwardRef<HTMLElement, SlideUpProps>(SlideUp);
